import { Dossier } from '@sc/data-access-models';

export interface Error {
  name?: string;
  message?: string;
  code?: string;
  status?: number;
  severity?: string;
}

export interface FreeSlotsResult {
  appointments?: any;
  fitter?: any;
  dotFitters?: any;
  globalScores?: any;
  status?: any;
}

export interface NewDossier {
  dossier: Dossier;
}

export interface UpdatedDossier {
  dossier: Dossier;
  updateType: DossierUpdateEventType[];
}

export interface DepartingDossier {
  dossierId: string;
  oldFitterId: string;
  newFitterId: string;
}

export enum DossierUpdateEventTypeEnum {
  documents = 'documents',
  apmtTime = 'apmtTime',
  apmtCancel = 'apmtCancel',
}

export type DossierUpdateEventType = `${DossierUpdateEventTypeEnum}`;

export interface OpenDossier {
  dossier: Dossier;
}

export interface CloseDossier {
  dossier: Dossier;
}

export interface LastPing {
  ok: boolean;
  date: Date;
}
